module.exports = __webpack_public_path__ + "img/ic-yahoo.53e99deb.svg";